export function useAppAuthorizationHeader() {
  const appAuthToken = useCookie<{ authToken: string }>('dbc-login')
  const appAuthorizationHeader = shallowRef<{ Authorization: string }>()

  if (appAuthToken.value) {
    appAuthorizationHeader.value = {
      Authorization: `Bearer ${appAuthToken.value.authToken}`,
    }
  }

  return {
    appAuthorizationHeader: appAuthorizationHeader.value,
  }
}
